import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useAppContext } from '../context/AppContext';

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};

const rewardVariants = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: { 
    opacity: 1, 
    scale: 1,
    transition: {
      duration: 0.4,
      ease: "backOut"
    }
  },
  hover: {
    scale: 1.05,
    transition: {
      duration: 0.2
    }
  }
};

const EarnedRewards = ({ childId }) => {
  const { getChildById } = useAppContext();
  const child = getChildById(childId);

  if (!child) return null;

  return (
    <motion.div
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      className="bg-white rounded-xl shadow-sm border border-gray-200 p-6"
    >
      <h3 className="text-xl font-bold text-gray-900 mb-6">Earned Rewards</h3>

      <AnimatePresence>
        {child.earnedRewards.length > 0 ? (
          <motion.div 
            variants={containerVariants}
            className="grid grid-cols-1 md:grid-cols-2 gap-4"
          >
            {child.earnedRewards.map((reward, index) => (
              <motion.div
                key={reward.id}
                variants={rewardVariants}
                whileHover="hover"
                className="bg-gradient-to-br from-green-50 to-emerald-50 border border-green-200 rounded-lg p-4"
              >
                <div className="flex items-start space-x-3">
                  <motion.div
                    animate={{ rotate: [0, 10, -10, 0] }}
                    transition={{ duration: 2, repeat: Infinity, repeatDelay: 3 }}
                    className="text-2xl"
                  >
                    🏆
                  </motion.div>
                  <div className="flex-1">
                    <h4 className="font-semibold text-green-800">{reward.title}</h4>
                    <p className="text-sm text-green-600 mt-1">{reward.description}</p>
                    <div className="flex items-center justify-between mt-2">
                      <span className="text-xs text-green-500">
                        Earned on {new Date(reward.earnedDate).toLocaleDateString()}
                      </span>
                      <motion.span
                        animate={{ scale: [1, 1.1, 1] }}
                        transition={{ duration: 1, repeat: Infinity, repeatDelay: 2 }}
                        className="text-lg"
                      >
                        ✨
                      </motion.span>
                    </div>
                  </div>
                </div>
              </motion.div>
            ))}
          </motion.div>
        ) : (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center py-12"
          >
            <motion.div
              animate={{ y: [0, -10, 0] }}
              transition={{ duration: 3, repeat: Infinity }}
              className="text-6xl mb-4"
            >
              🎁
            </motion.div>
            <p className="text-gray-500 text-lg">No rewards earned yet.</p>
            <p className="text-gray-400 text-sm mt-2">Keep up the good sleep routine!</p>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
};

export default EarnedRewards;